import './App.css';
import Footer from './components/common/Footer';
import Nav from './components/common/Nav';
import Hero from './components/home/Hero';
import { CityCafe } from './components/home/CityCafe';
import { Partners, Tycoons } from './components/home/Partners';
import { Resale } from './components/home/Resale';
import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import Connect from './components/connect/Connect';
import Latest from './components/home/Latest';
import { useLocation } from "react-router-dom";
import { useEffect } from 'react';
import Numbers from './components/common/Numbers';
import AdminLogin from './components/admin/Adminlogin';

import AdminDashboard from './components/admin/AdminDashboard';

import About from './components/about/About';
import Testimonials from './components/common/Testimonials';
import TourPackages from './components/tourPackages/TourPackages';
import BharatIntro from './components/home/BharatIntro';
import WhyChooseUs from './components/home/WhyChooseUs';
import PrivacyPolicy from './components/policy/PrivacyPolicy';
import Terms from './components/policy/Terms';
import Gallery from './components/home/Gallery';
import TaxiServiceList from './components/taxiService/TaxiServiceList';
import { TourPackageList } from './components/tourPackages/TourPackageList';
import TaxiServicePage from './components/taxiService/TaxiServicePage';


const Home = () => {
  return (
    <>
      <Hero />
      <BharatIntro />
      <Latest />
      <TourPackageList />
      <CityCafe />
      <Numbers />
      <Partners />
      <WhyChooseUs />
      <Testimonials />
      <Gallery />
      <Resale />
    </>
  )
}


const App = () => {
  const location = useLocation();
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: location.pathname,
    });
  }, [location]);


  const PublicLayout = () => {
    return (
      <>
        <Nav />
        <Outlet />
        <Footer />
      </>
    );
  }

  const ProtectedRoute = () => {
    const isAuthenticated = sessionStorage.getItem("phone");
    return isAuthenticated ? <Outlet /> : <Navigate to="/admin" replace />;
  }

  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Connect />} />
        <Route path="/about" element={<About />} />
        <Route path="/packages" element={<TourPackages />} />

        <Route path="/taxi-service" element={<TaxiServiceList />} />
        <Route path="/taxi-service/:city" element={<TaxiServicePage />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<Terms />} />

        <Route path="/*" element={<Home />} />
        <Route path="/admin" element={<AdminLogin />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<AdminDashboard />} />
      </Route>
    </Routes>
  )
}

export default App;